export default __webpack_public_path__ + "static/media/Sad.ad28d4ae.gif";